var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"46AFA612-8580-4D96-899D-8BBCF2582FF3"),React.createElement("g",{"id":"Assety","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Asset:-UI","transform":"translate(-322.000000, -98.000000)","fillRule":"nonzero"},React.createElement("path",{"d":"M338,98 L337.999,99.466 L338,99.4679579 L337.999,99.468 L338,113 L336,113 L335.999,101.468 L323.467958,114 L322,112.532042 L334.532,100 L323,100 L323,98 L338,98 Z","id":"arrow"})))]);
}

ArrowInline.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
